import { format } from 'date-fns'

import * as api from '../api'
import useApiMutation from './useApiMutation'
import useInvalidate from '../useInvalidate'

export default function useUpdateGroupLearningAssignment() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async ({ uuid, dueDate }: { uuid: string; dueDate?: Date }) => {
      await api.put(`course/assignment/group/${encodeURIComponent(uuid)}`, {
        due_date: dueDate ? format(dueDate, 'yyyy-MM-dd') : '',
      })
      await Promise.all([invalidate.groups(), invalidate.users()])
    },
  })
}
